var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgThumbDownFill = function SvgThumbDownFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16q-.8 0-1.4-.6T1 14v-2a2 2 0 0 1 .15-.75l3-7.05q.225-.5.75-.85T6 3h8q.825 0 1.412.587Q16 4.176 16 5v10.175q0 .4-.162.762a2.1 2.1 0 0 1-.438.638l-5.425 5.4q-.375.35-.887.425a1.58 1.58 0 0 1-.988-.175 1.5 1.5 0 0 1-.687-.7q-.213-.45-.088-.925L8.45 16zM20 3q.824 0 1.413.587Q22 4.176 22 5v9q0 .825-.587 1.412A1.93 1.93 0 0 1 20 16q-.824 0-1.413-.588A1.93 1.93 0 0 1 18 14V5q0-.824.587-1.412A1.93 1.93 0 0 1 20 3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThumbDownFill);
export { ForwardRef as ReactComponent };